// Filters the rounds table on the golfer career page without a page reload.
// Every round is already in the DOM, so filtering is a class toggle rather
// than a request. Turbolinks, not Turbo, so init runs on both events.

const GolferRoundsFilter = {
  init() {
    const root = document.getElementById('golfer-rounds');
    if (!root || root.dataset.filterReady === 'true') return;
    root.dataset.filterReady = 'true';

    const selects = Array.from(root.querySelectorAll('[data-round-filter]'));
    const rows = Array.from(root.querySelectorAll('[data-round-row]'));
    const count = root.querySelector('[data-round-count]');
    const empty = root.querySelector('[data-round-empty]');
    const clear = root.querySelector('[data-round-clear]');

    function activeFilters() {
      const filters = {};
      selects.forEach((select) => {
        if (select.value) filters[select.dataset.roundFilter] = select.value;
      });
      return filters;
    }

    function apply() {
      const filters = activeFilters();
      const keys = Object.keys(filters);
      let shown = 0;

      rows.forEach((row) => {
        const matches = keys.every((key) => row.dataset[key] === filters[key]);
        row.classList.toggle('hidden', !matches);
        if (matches) shown += 1;
      });

      if (count) count.textContent = shown;
      if (empty) empty.classList.toggle('hidden', shown > 0);
      if (clear) clear.classList.toggle('hidden', keys.length === 0);

      syncUrl(filters);
    }

    // Keeps the URL shareable without navigating.
    function syncUrl(filters) {
      if (!window.history || !window.history.replaceState) return;

      const url = new URL(window.location.href);
      selects.forEach((select) => {
        const param = select.name;
        if (filters[select.dataset.roundFilter]) {
          url.searchParams.set(param, select.value);
        } else {
          url.searchParams.delete(param);
        }
      });
      // Pass the CURRENT state through, never {}. Turbolinks keeps its
      // restorationIdentifier in history.state, and onPopState ignores any
      // entry that lacks it -- clobbering it here left the back button
      // changing the URL without ever re-rendering the page.
      window.history.replaceState(window.history.state, '', url);
    }

    // The title/filters block above the table is sticky, so the table header has
    // to stick directly below it rather than at the bare nav offset. That block
    // changes height as the filters wrap, so measure it and publish the total as
    // a custom property the <th> cells read.
    // 128px nav plus the 16px band that sits across the top of the page, which
    // is what the sticky blocks below pin against.
    const NAV_OFFSET = 144; // Tailwind top-36
    const header = root.querySelector('[data-rounds-header]');

    function syncStickyOffset() {
      if (!header) return;
      root.style.setProperty('--rounds-th-top', `${NAV_OFFSET + header.getBoundingClientRect().height}px`);
    }

    if (header) {
      syncStickyOffset();
      // Observing the block covers viewport resizes too, since those are what
      // make the filters rewrap. A window listener would leak across visits.
      if (window.ResizeObserver) new ResizeObserver(syncStickyOffset).observe(header);
    }

    selects.forEach((select) => select.addEventListener('change', apply));

    if (clear) {
      clear.addEventListener('click', (event) => {
        event.preventDefault();
        selects.forEach((select) => { select.value = ''; });
        apply();
      });
    }

    apply();
  }
};

document.addEventListener('DOMContentLoaded', GolferRoundsFilter.init);
document.addEventListener('turbolinks:load', GolferRoundsFilter.init);

// Turbolinks caches the DOM with data-filter-ready already set, so the flag
// has to be cleared before caching. Otherwise init() short-circuits when the
// snapshot is restored by the back button and the restored nodes, which are
// new elements, never get their listeners.
document.addEventListener('turbolinks:before-cache', () => {
  const root = document.getElementById('golfer-rounds');
  if (root) delete root.dataset.filterReady;
});

export default GolferRoundsFilter;
